import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { constant } from '../../app.constants';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import {Trip} from '../A2-utils/live-map/live-map.component';

@Injectable()
export class CompaniesService extends ParentService {
     constructor(private _http: Http, private route: Router) {
        super();
        // this.verifyToken(this._http, this.route);
    }

    /**
     * @Description:
     * @param {string} method
     * @returns {Observable<any>}
     */
    getCompanies(method: string) {
        if (method === 'all') {
            return this._http.get(constant.URL_ENABLE_PROVIDER, this.getHeader())
                .map(res => res.json())
                .catch((error: any ) => Observable.throw(error.json()));

        } else {
            return this._http.get(constant.URL_DISABLE_PROVIDER, this.getHeader())
                .map(res => res.json() )
                .catch(( error: any ) => Observable.throw(error.json()));
        }
    }

    /**
     * @Description:
     * @param date
     * @returns {Observable<any>}
     */
    getBrokersWithTripCount(date) {
        return this._http.get(constant.URL_GET_BROKERS_TRIP_NUMBER + date, this.getHeader())
            .map(res => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @returns {Observable<any>}
     */
    getAllBrokers() {
        return this._http.get(constant.URL_ENABLE_PROVIDER, this.getHeader())
            .map(res => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @param payorid
     * @returns {Observable<any>}
     */
    getBrokersByPayor(payorid) {
        return this._http.get(constant.URL_GET_BROKERS_BY_PAYOR + payorid, this.getHeader())
            .map(res => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @returns {Observable<any>}
     */
    getCompaniesNotOnDemand() {
        return this._http.get(constant.BROKERS.URLS.BASE + 'ListNonOnDemand', this.getHeader())
            .map( res => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @returns {Observable<any>}
     */
    getCompaniesOnDemand() {
        return this._http.get(constant.BROKERS.URLS.BASE + 'ListByCategory/true', this.getHeader())
            .map( res => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @returns {Observable<any>}
     */
    getOnDemandCompanies() {
        // return this._http.get(constant.BROKERS.URLS.BASE + 'ListOnDemand', this.getHeader())
        return this._http.get(constant.URL_COMPANIES + '/ListOnDemand', this.getHeader())
            .map( res => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }


    /**
     * @Description:
     * @param {number} companyId
     * @returns {Observable<any>}
     */
    getCompany(companyId: number) {
        return this._http.get(constant.BROKERS.URLS.BASE + companyId, this.getHeader() )
            .map( res => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @param data
     * @returns {Observable<any>}
     */
    postData(data: any) {
        const bodyString = JSON.stringify(data);
        return this._http.post(constant.BROKERS.URLS.BASE, bodyString, this.headerPost())
            .map(( res: Response )  => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @param data
     * @returns {Observable<any>}
     */
    putData(data: any) {
        const bodyString = JSON.stringify(data);

        return this._http.put(constant.BROKERS.URLS.BASE, bodyString, this.headerPost())
            .map((res: Response ) => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @param data
     * @returns {Observable<any>}
     */
    deleteData(data: any) {

        return this._http.delete(`${constant.BROKERS.URLS.BASE}${data}`, this.headerPost())
            .map((res: Response ) => res.json())
            .catch((error: any ) => Observable.throw(error.json()));
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/companies/companies.service.ts